export const PRIMARY_CURRENCY = 'USDT'
